import { Route } from '@angular/router';

export const RemitosReportRoute: Route = {
  path: 'remitos-report',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/remitos_report_shell'
    ).then((c) => c.remitosReportShellRoutes);
  },
};
